export default "__VITE_ASSET__549fdc1f__"